import { styled } from 'styled-components';

import { styledReset, styledTypography } from '@pkg/primitives';

import { tokens } from './FilterStack.tokens.ts';

export const List = styled.ul`
    ${styledReset.list};
    --list-gap: ${tokens.list.gap.parent}px;

    display: grid;
    gap: var(--list-gap);

    ul {
        --list-gap: ${tokens.list.gap.child}px;
    }
`;

export const Item = styled.li`
    position: relative;
    display: grid;
    gap: ${tokens.item.gap}px;

    & + & {
        padding-top: var(--list-gap);
    }

    // Divider between items.
    // Not using 'border-top' so that we can
    // inset the left/right sides of the divider.
    & + &::before {
        content: '';
        display: block;
        position: absolute;
        left: ${tokens.item.gap * 2}px;
        right: ${tokens.item.gap * 2}px;
        height: 1px;
        background-color: rgb(255, 255, 255, 0.06);
    }
`;

export const Label = styled.p`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.label.size}px;
    font-weight: 700;
    text-transform: uppercase;
`;

export const Content = styled.div``;
